import { render, staticRenderFns } from "./MyCompanyUserTypesNew.vue?vue&type=template&id=2f0a5795&"
import script from "./MyCompanyUserTypesNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyUserTypesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports